import { parseReference } from '@skjv/common';
import { bibleState } from '@/state/bible-state';

interface InlineVerseRefProps {
  reference: string;
  displayText: string;
}

export function InlineVerseRef({ reference, displayText }: InlineVerseRefProps) {
  const location = parseReference(reference);

  if (!location) {
    return <span className="strongs-link">{displayText}</span>;
  }

  return (
    <button
      className="strongs-link verse-ref-link"
      onClick={() => bibleState.setCurrentLocation(location)}
    >
      {displayText}
    </button>
  );
}
